@if (supportedDataSources.length) {
  <div class="lb-card" [class.lb-card--configured]="!!dataSourceId">
    <div
      class="lb-header"
      [class.lb-header--disabled]="!hasScore"
      [matTooltip]="'campaign.widget.sidebar.form-settings-v2.leaderboard-needs-score' | translate"
      [matTooltipDisabled]="hasScore"
      (click)="hasScore ? toggleExpansion() : null">
      <mat-icon class="lb-header__icon">leaderboard</mat-icon>
      <div class="lb-header__name">
        {{ "campaign.widget.sidebar.form-settings-v2.leaderboard-title" | translate }}
      </div>
      <div class="lb-spacer"></div>
      @if (dataSourceId) {
        <span class="lb-header__active">
          <mat-icon class="lb-header__status">check</mat-icon>
          {{ "campaign.widget.sidebar.form-settings-v2.active-badge" | translate }}
        </span>
      }
      <mat-icon class="lb-chevron">{{ expanded ? "expand_less" : "expand_more" }}</mat-icon>
    </div>

    @if (expanded) {
      <div class="lb-body" @expandReveal>
        <mat-form-field class="lb-field" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ "campaign.widget.sidebar.form-settings-v2.leaderboard-select" | translate }}</mat-label>
          <mat-select [(ngModel)]="dataSourceId" [disabled]="saving" (selectionChange)="onDataSourceChange()">
            <mat-option [value]="null">{{ "generic.none" | translate }}</mat-option>
            @for (source of supportedDataSources; track source.id) {
              <mat-option [value]="source.id">{{ source.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
}
